<template>
  <div class="boxDetail">
    <div
      style="display: flex; flex-direction: column; flex: 1; overflow: scroll"
    >
      <div class="image">
        <img
          class="back"
          src="../../assets/images/score/back.png"
          @click="() => back()"
        />
        <img
          :src="data?.materialPhotos || ''"
          style="object-fit: contain"
          @error="setDefaultImage"
        />
      </div>
      <div class="mainBox">
        <div class="titleBox">
          <p class="title">{{ data?.materialName || '-' }}</p>
          <div class="numBox">
            <div class="numName">
              <img src="../../assets/images/score/redBase.png" />
              <p class="allText">{{ data?.externalSalePrice || '' }}</p>
            </div>
            <van-stepper v-model="value" :min="1" integer @change="change" />
          </div>
        </div>
        <div class="detail">
          <titleLine v-for="item in list" :key="item.title" :data="item" />
        </div>
      </div>
    </div>
    <bottom
      :total="amount"
      :rest-score="restScore"
      :bonus-points="bonusPoints"
      @click="applyGoods"
      @pay-type="changePayType"
    />
  </div>
</template>

<script lang="ts" setup>
import Bottom from '@/views/score/component/scoreMain/bottom.vue'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import TitleLine from '@/views/score/component/scoreMain/titleLine.vue'
import {
  GoodsApplyReq,
  goodsDetailResp,
  GoodsRecordModal
} from '@/model/score/GoodsModel'
import { getGoodsDetail, getMyScore, goodsApply } from '@/api/requests/score'
import { useUserStore } from '@/stores/user'
import { destroyH5 } from '@/utils/nativeAPI'
import img_failed from '@/assets/images/score/img_failed.png'
import { showConfirmDialog, showToast } from 'vant'
import { loading } from '@/utils/loading'
import lang from '@/langs'
const setDefaultImage = (event) => {
  event.target.src = img_failed
}
const router = useRouter()
const value = ref(1)
const route = useRoute()
const tempData = route?.query?.data || ''
const tempType = route?.query?.isH5 || ''
const data = ref<goodsDetailResp>()
const restScore = ref(0)
const amount = ref(0)
const bonusPoints = ref(0)
const pointsType = ref(1)
const changePayType = (value: string) => {
  pointsType.value = Number(value)
  updateParam()
}
const initialParam = (): GoodsApplyReq => ({
  quantity: value.value,
  materialId: tempData as string,
  redeemPoints: amount.value,
  price: data.value?.externalSalePrice || 0,
  amount: amount.value,
  pointsType: pointsType.value
})
const param = ref<GoodsApplyReq>(initialParam())
const updateParam = () => {
  param.value = initialParam()
}
const getDetail = () => {
  getGoodsDetail({ salesPriceId: tempData as string }).then((res) => {
    if (res.code === 1) {
      data.value = res.data
      amount.value = value.value * data.value.externalSalePrice
      list.value = initialList()
      updateParam()
    } else {
      showToast(res.msg)
    }
  })
}
const applyGoods = () => {
  showConfirmDialog({
    message: lang('确认进行兑换吗？'),
    confirmButtonColor: 'rgba(255, 0, 0, 1)',
    confirmButtonText: lang('确认'),
    cancelButtonText: lang('取消')
  })
    .then(() => {
      goodsApply(param.value).then((value) => {
        if (value.code === 1) {
          router.replace({
            path: '/scoreResult',
            query: { status: 'true', msg: data.value?.materialName || '' }
          })
        } else {
          router.replace({
            path: '/scoreResult',
            query: { status: 'false', msg: data.value?.materialName || '' }
          })
        }
      })
    })
    .catch(() => {
      // on cancel
    })
}
const getScore = () => {
  loading.show()
  getDetail()
  getMyScore({ stationCode: useUserStore().nativeInfo.stationCode })
    .then((value) => {
      if (value.code === 1) {
        restScore.value = value.data.pointsAmount
        bonusPoints.value = value.data.bonusPoints
      }
    })
    .finally(() => {
      loading.hide()
    })
}
const initialList = () => [
  {
    title: lang('兑换须知'),
    sub1: lang('1.积分一经兑换不可退还,请谨慎兑换'),
    sub2: lang('2.兑换成功后,平台将在5个工作日内送达,请耐心等待')
  },
  {
    title: lang('商品详情'),
    sub1: data.value?.materialDecr || '--',
    sub2: ' '
  }
]
const list = ref(initialList())
const change = () => {
  amount.value = value.value * (data.value?.externalSalePrice || 0)
  updateParam()
}
const back = () => {
  if (tempType === '') {
    destroyH5()
  } else {
    router.go(-1)
  }
}
onMounted(() => {
  // getNativeInfo()
  getScore()
  console.log('*********gengxinle')
})
</script>

<style scoped lang="less">
.boxDetail {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .image {
    position: relative;
    > img {
      width: 100%;
      aspect-ratio: 1 / 1;
    }
    .back {
      width: 25px;
      height: 25px;
      position: absolute;
      //position: relative;
      z-index: 9;
      top: 16px;
      left: 16px;
      background: #706969;
      border-radius: 50%;
    }
  }
  .mainBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    //overflow: scroll;
    .titleBox {
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 16px 16px;
      .title {
        font-size: 16px;
      }
      .numBox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;
        .numName {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          > img {
            width: 12px;
            height: 12px;
          }
          .allText {
            font-size: 18px;
            color: rgba(255, 0, 0, 1);
            margin-left: 4px;
            font-weight: bold;
          }
        }
      }
    }
    .detail {
      display: flex;
      flex-direction: column;
      //flex: 1;
      //overflow: scroll;
      background: #fff;
      margin-top: 8px;
      padding-top: 16px;
    }
  }
}
</style>
